import { Count } from '../models';
import { EntityId } from '../types/types';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResultListResponse } from '../responses/result-list-response';

export class BaseService<T> {

    private innerPath: string = '';

    constructor(
        protected apiPath: string,
        protected http: HttpClient
    ) { }

    protected get apiFullPath(): string {
        return this.buildPath();
    }

    appendPath(path: string): void {
        this.innerPath = path;
    }

    count(filter?: any): Observable<Count> {
        const httpParams = this.buildQueryStringParams({ filter });

        const path = this.buildPath();

        return this.http.get(`${path}/count`, {
            params: httpParams
        }) as Observable<Count>;
    }

    get(filter?: any, order: string = '', desc: boolean = false, page: number = 0, size: number = 0): Observable<ResultListResponse<T>> {
        let httpParams = this.buildQueryStringParams({ filter });

        const path = this.buildPath();

        if (!!order) httpParams = httpParams.set('order', order);
        if (!!desc) httpParams = httpParams.set('desc', desc);

        return this.http.get(`${path}`, {
            params: httpParams
                .set('page', `${page}`)
                .set('size', `${size}`)
        }) as Observable<ResultListResponse<T>>;
    }

    getById(id: EntityId): Observable<T> {
        const path = this.buildPath();

        return this.http.get(`${path}/${id}`) as Observable<T>;
    }

    post(data: T): Observable<T> {
        const path = this.buildPath();

        return this.http.post(`${path}`, data) as Observable<T>;
    }

    put(id: EntityId, data: T): Observable<unknown> {
        const path = this.buildPath();

        return this.http.put(`${path}/${id}`, data) as Observable<unknown>;
    }

    archive(id: EntityId, status: boolean): Observable<unknown> {
        const path = this.buildPath();

        return this.http.put(`${path}/${id}/archive`, { status }) as Observable<unknown>;
    }

    delete(id: EntityId): Observable<unknown> {
        const path = this.buildPath();

        return this.http.delete(`${path}/${id}`) as Observable<unknown>;
    }

    duplicate(id: EntityId): Observable<unknown> {
        const path = this.buildPath();

        return this.http.post(`${path}/duplicate/${id}`, undefined) as Observable<T>;
    }

    restore(id: EntityId): Observable<unknown> {
        const path = this.buildPath();

        return this.http.put(`${path}/${id}/restore`, undefined) as Observable<unknown>;
    }

    export(filter?: any): Observable<unknown> {
        const httpParams = this.buildQueryStringParams({ filter });

        const path = this.buildPath();

        return this.http.get(`${path}/export`, {
            params: httpParams,
            responseType: 'blob' as 'json'
        }) as Observable<unknown>;
    }

    import(data: FormData): Observable<unknown> {
        const path = this.buildPath();

        return this.http.post(`${path}/import`, data) as Observable<unknown>;
    }

    protected buildPath(): string {
        return `${environment.apiUrl}${this.apiPath}${this.innerPath ? `/${this.innerPath}` : ''}`;
    }

    protected buildQueryStringParams(params: any): HttpParams {
        var httpParams = new HttpParams();

        if (!params) return httpParams;

        for (const [paramName, paramValue] of Object.entries(params)) {
            if (!paramValue) continue;

            const pV = paramValue as any;

            for (const k of Object.keys(pV)) {
                httpParams = httpParams.set(`${paramName}[${k.toLowerCase()}]`, pV[k]);
            }
        }

        return httpParams;
    }
}